import React from "react";
import { useEffect, useState } from "react";
import "./CreateTicket.css";
import {
  Button,
  Modal,
  Input,
  Row,
  Select,
  Tooltip,
  DatePicker,
  notification,
  Modal as modal,
  Space as space,
  Button as button,
} from "antd";
import PrimaryButton from "../../CommonComponent/Buttons/PrimayButton";
import { Form } from "@ant-design/compatible";
import moment from "moment";
import AddIconBlue from "../../images/AddIconBlue.svg";
import axios from "axios";
import Config from "../../../config";
import AddAttachment from "./AddAttachmentModel/AddAttachment";
import EditIcon from "../../images/EditIcon.svg";
import DeleteIcon from "../../images/DeleteIcon.svg";
import DeleteModal from "../../UserRegistration/DeleteModal";

const { TextArea } = Input;
const { Option } = Select;
const dateFormat = "MM/DD/YYYY";

function CreateTicket(props) {
  const isTicketManagement =
    props.fromWhere == "Ticket Management" ? true : false;
  const { getFieldDecorator, setFieldsValue } = props.form;
  const [ticketData, setTicketData] = useState({
    Description: "",
    POCName: "",
    POCContactNumber: "",
    POCEmail: "",
    AssignedNPI: "",
    AssignedTaxID: "",
    OriginQueueID: "",
    TenantID: sessionStorage.getItem("Tanent"),
    TicketCreatedFor: props.TicketCreatedForProps
      ? props.TicketCreatedForProps
      : "",
    TicketCreatedForID: props.TicketCreatedForIDProps
      ? props.TicketCreatedForIDProps
      : "",
    TicketTypeID: "",
    CreatedBy: sessionStorage.getItem("userEmail"),
    CreatedByUserRole: sessionStorage.getItem("userRole"),
    CreatedByUserName: sessionStorage.getItem("userName"),
    Files: [],
  });
  const [ticketShowNew, setTicketShowNew] = useState(false);
  const [copyToPOC, setCopyToPOC] = useState(false);
  const [getTicketData, setGetTicketData] = useState([]);
  const [showDocument, setShowDocument] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [formatMismatch, setFileFormatMismatch] = useState(false);
  const [sizeExceeded, setFileSizeExceeded] = useState(false);
  const [name, setName] = useState(sessionStorage.getItem("userName"));
  const [email, setEmail] = useState(sessionStorage.getItem("userEmail"));
  const [phone, setPhone] = useState(sessionStorage.getItem("phoneNumber"));
  const [deleteModel, setDeleteModel] = useState(false);
  const [isUpdateModel, setIsUpdateModel] = useState(false);
  // console.log("smthing", props.TicketHideInfo);
  // console.log("from where", props.Fromwhere)
  // console.log("TicketCreatedForProps",props.TicketCreatedForProps);

  const getTicketMasterData = async () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({}),
    };

    await axios
      .get(
        Config.Ticket +
          "/getmasterdata?TenantID=" +
          sessionStorage.getItem("Tanent"),
        axiosConfig
      )
      .then((res) => {
        setGetTicketData(res.data);
        setTicketData({
          ...ticketData,
          OriginQueueID: res.data.QueueMaster.find(
            (e) => e.Queue === props.Fromwhere
          ).QueueID,
        });
      })
      .catch((err) => {});
  };
  console.log("propss", props.Fromwhere);

  const ticketCreate = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    formData.append("Description", ticketData.Description);
    formData.append("POCName", ticketData.POCName);
    formData.append("POCContactNumber", ticketData.POCContactNumber);
    formData.append("POCEmail", ticketData.POCEmail);
    formData.append("AssignedNPI", ticketData.AssignedNPI);
    formData.append("AssignedTaxID", ticketData.AssignedTaxID);
    formData.append("OriginQueueID", ticketData.OriginQueueID);
    formData.append("TenantID", ticketData.TenantID);
    formData.append("TicketCreatedFor", ticketData.TicketCreatedFor);
    formData.append("TicketCreatedForID", ticketData.TicketCreatedForID);
    formData.append("TicketTypeID", ticketData.TicketTypeID);
    formData.append("CreatedBy", ticketData.CreatedBy);
    formData.append("CreatedByUserRole", ticketData.CreatedByUserRole);
    formData.append("CreatedByUsername", ticketData.CreatedByUserName);
    formData.append("PlanName",sessionStorage.getItem("planName"));


    ticketData.Files.map((file, index) => {
      return formData.append(`File${index + 1}`, file, file.name);
    });

    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    props.form.validateFields(async (err, values) => {
      if (!err) {
        await axios
          .post(Config.Ticket + "/CreateTicket", formData, axiosConfig)
          .then((res) => {
            // console.log(res, "resdata");
            // setTicketData(res.data);
            if (res.status === 200) {
              notification.success({
                message: res.data.Message,
                status: "success",
              });
              if (props.fromWhere == "Ticket Management") {
                props.remove(props.activeKey);
              }
              {
                props.TicketHideInfo(true);
              }
            } else {
              notification.error({
                message:
                  "Unable to create a ticket at this time. Please check the data entered and try again.",
                status: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  useEffect(() => {
    getTicketMasterData();
  }, []);

  const cancelButton = () => {
    props.remove(props.activeKey);
  };

  const openModal = () => {
    setShowDocument(true);
    setIsUpdateModel(false);
  };

  const handleOk = () => {
    setShowDocument(false);
  };

  const handleCancel = () => {
    setShowDocument(false);
    setDeleteModel(false);
  };

  const toggleUpdateHandler = () => {
    setIsUpdateModel(!isUpdateModel);
  };

  const handleTicketTypeChange = (value) => {
    setTicketData({
      ...ticketData,
      TicketTypeID: value,
    });
  };

  const handleAssignedTaxIDChange = (value) => {
    setTicketData({
      ...ticketData,
      AssignedTaxID: value,
    });
  };

  const handleAssignedNPIChange = (value) => {
    setTicketData({
      ...ticketData,
      AssignedNPI: value,
    });
  };

  const handlePOCNameChange = (e) => {
    const value = e.target.value;
    setTicketData({
      ...ticketData,
      POCName: value,
    });
  };

  const handlePOCPhoneChange = (e) => {
    const value = e.target.value;
    setTicketData({
      ...ticketData,
      POCContactNumber: value,
    });
  };

  const TicketHideInfo = () => {
    setTicketShowNew(false);
  };

  const HideTicketForm = () => {
    window.location.reload();
  };

  const warning = () => {
    if (props.fromWhere == "Ticket Management") {
      modal.confirm({
        title: "Are you sure to cancel",
        content: "cancel will discard all the added data",
        onOk() {
          cancelButton();
        },
        okText: "Yes, Cancel",
        cancelText: "No",
      });
    } else {
      modal.confirm({
        title: "Are you sure to cancel",
        content: "cancel will discard all the added data",
        onOk() {
          props.TicketHideInfo(true);
        },
        okText: "Yes, Cancel",
        cancelText: "No",
      });
    }
  };

  const handlePOCEmailChange = (e) => {
    const value = e.target.value;
    setTicketData({
      ...ticketData,
      POCEmail: value,
    });
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setTicketData({
      ...ticketData,
      Description: value,
    });
  };

  const handleCheckBox = (e) => {
    setCopyToPOC(e.target.checked);
    if (e.target.checked) {
      setFieldsValue({ pocName: name });
      setFieldsValue({ pocContactNumber: phone });
      setFieldsValue({ pocEmail: email });

      setTicketData({
        ...ticketData,
        POCName: name,
        POCContactNumber: phone,
        POCEmail: email,
      });
    } else {
      setTicketData({
        ...ticketData,
        POCName: "",
        POCContactNumber: "",
        POCEmail: "",
      });
      setFieldsValue({ pocName: "" });
      setFieldsValue({ pocContactNumber: "" });
      setFieldsValue({ pocEmail: "" });
    }
  };

  const taxidNpiMapping = JSON.parse(sessionStorage.getItem("taxidNpiMapping"));
  const taxidOptions = taxidNpiMapping?.map((item) => (
    <Option key={item.TaxID} value={item.TaxID}>
      {item.TaxID}
    </Option>
  ));
  const npiOptions = taxidNpiMapping
    ?.find((e) => e.TaxID === ticketData.AssignedTaxID)
    ?.NPI?.map((item) => (
      <Option key={item} value={item}>
        {item}
      </Option>
    ));

  const selectTaxId = taxidOptions || (
    <Option
      key={JSON.parse(sessionStorage.getItem("taxid"))}
      value={JSON.parse(sessionStorage.getItem("taxid"))}
    >
      {JSON.parse(sessionStorage.getItem("taxid"))}
    </Option>
  );

  const selectNpiId = npiOptions || (
    <Option
      key={JSON.parse(sessionStorage.getItem("npivalue"))}
      value={JSON.parse(sessionStorage.getItem("npivalue"))}
    >
      {JSON.parse(sessionStorage.getItem("npivalue"))}
    </Option>
  );

  const documentAction = (type) => {
    if (type === "delete") {
      setDeleteModel(true);
    }
    if (type === "edit") {
      setShowDocument(true);
      setIsUpdateModel(true);
    }
  };
  const loc = window.location.toString().includes("userDetails");

  return (
    <div>
      <div>
        {isTicketManagement && <div className="addIncident">Create Ticket</div>}
      </div>
      <>
        <Form>
          <div className="fieldBackground">
            <div className="addIncident">01. Basic Information</div>
            <div className="formDesignRow">
              <div style={{ width: "18%" }}>
                <span className="addStaff-text">User's Name </span>
                <Form.Item>
                  <Input
                    size="small"
                    name="callerFirstName"
                    placeholder="Enter"
                    value={name}
                    disabled={true}
                  />
                </Form.Item>
              </div>

              <div style={{ width: "18%" }}>
                <span className="addStaff-text">Contact No. </span>
                <Form.Item>
                  <Input
                    size="small"
                    name="callerContactNumber"
                    placeholder="Enter"
                    value={phone}
                    disabled={true}
                  />
                </Form.Item>
              </div>

              <div style={{ width: "18%" }}>
                <span className="addStaff-text">Email Address </span>
                <Form.Item>
                  <Input
                    size="small"
                    name="callerTitle"
                    placeholder="Enter"
                    value={email}
                    disabled={true}
                  />
                </Form.Item>
              </div>

              <div style={{ width: "18%" }}>
                <span className="addStaff-text">Created Date </span>
                <Form.Item>
                  <DatePicker
                    size="small"
                    disabled
                    defaultValue={moment()}
                    format={dateFormat}
                  />
                </Form.Item>
              </div>
            </div>
          </div>

          <div className="fieldBackground">
            <div className="addIncident">02. Ticket Details</div>
            <div className="textArea textField">
              <div className="incidentFlex">
                <span className="addStaff-text1">
                  Description
                  <span style={{ color: "red" }}>*</span>
                </span>
              </div>
              <Form.Item>
                {getFieldDecorator("description", {
                  rules: [
                    {
                      required: true,
                      message: "This field is mandatory",
                    },
                  ],
                })(
                  <TextArea
                    className="addStaff"
                    placeholder="Type here"
                    autoSize={{ minRows: 3 }}
                    onChange={handleDescriptionChange}
                    maxLength={5001}
                    value={ticketData.Description}
                  />
                )}
              </Form.Item>

              {ticketData.Description?.length > 5000 && (
                <div className="customErrorText">
                  This field allows upto 5000 characters only.
                </div>
              )}
            </div>
            <div className="formDesignRow">
              <div style={{ width: "18%" }}>
                <span className="addStaff-text">
                  Ticket Type
                  <span style={{ color: "red" }}>*</span>
                </span>
                <Form.Item>
                  {getFieldDecorator("ticketType", {
                    rules: [
                      {
                        required: true,
                        message: "This field is mandatory",
                      },
                    ],
                  })(
                    <Select
                      size="small"
                      placeholder="Select"
                      onChange={handleTicketTypeChange}
                    >
                      <Option value="">
                        <span>Select</span>
                      </Option>
                      {getTicketData.TicketType?.map((item) => {
                        return (
                          <Option
                            key={item.TicketTypeID}
                            value={item.TicketTypeID}
                          >
                            {item.TicketType}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                </Form.Item>
              </div>
              {sessionStorage.getItem("rolename").includes("Group User") ||
              sessionStorage.getItem("rolename").includes("IPA User") ||
              sessionStorage.getItem("rolename").includes("Provider") ? (
                <>
                  <div style={{ width: "25%" }}>
                    <span className="addStaff-text">
                      TIN (Select a Tax ID that the ticket should be associated
                      with) <span style={{ color: "red" }}>*</span>
                    </span>
                    <Form.Item>
                      {getFieldDecorator("taxid", {
                        rules: [
                          {
                            required: true,
                            message: "This field is mandatory",
                          },
                        ],
                      })(
                        <Select
                          size="small"
                          placeholder="Select"
                          onChange={handleAssignedTaxIDChange}
                        >
                          <Option value="">
                            <span>Select</span>
                          </Option>
                          {selectTaxId}
                        </Select>
                      )}
                    </Form.Item>
                  </div>
                  <div style={{ width: "25%" }}>
                    {ticketData.AssignedTaxID ? (
                      <>
                        <span className="addStaff-text">
                          NPI (Select a Tax ID that the ticket should be
                          associated with){" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                        <Form.Item>
                          {getFieldDecorator("npiid", {
                            rules: [
                              {
                                required: true,
                                message: "This field is mandatory",
                              },
                            ],
                          })(
                            <Select
                              size="small"
                              placeholder="Select"
                              onChange={handleAssignedNPIChange}
                            >
                              <Option value="">
                                <span>Select</span>
                              </Option>
                              {selectNpiId}
                              {/* {JSON.parse(sessionStorage.getItem('taxidNpiMapping')).find(e => e.TaxID === ticketData.AssignedTaxID).NPI?.map(
                                                              (item) => {
                                                                  return (
                                                                      <Option
                                                                          key={item}
                                                                          value={item}
                                                                      >
                                                                          {item}
                                                                      </Option>
                                                                  );
                                                              }
                                                          )} */}
                            </Select>
                          )}
                        </Form.Item>
                      </>
                    ) : null}
                  </div>
                </>
              ) : null}
            </div>
            {ticketData.Files?.length == 0 && (
              <div className="ml-4">
                <button
                  type="button"
                  className="cancle-button px-3 my-3"
                  onClick={openModal}
                >
                  <img
                    className="mr-2"
                    src={AddIconBlue}
                    style={{ height: "15px", width: "15px" }}
                  />
                  <b>Add Attachment</b>
                </button>
              </div>
            )}
            {ticketData.Files?.length > 0 && (
              <>
                <div className="addIncident">Attached Document</div>
                <div className="formDesignRow">
                  <div>
                    <span className="addStaff-text">File </span>
                    <Form.Item>
                      <div
                        style={{
                          display: "flex",
                          gap: "40px",
                        }}
                      >
                        {ticketData.Files.map((item) => {
                          return (
                            <Tooltip title={item.name}>
                              <Input
                                readOnly={true}
                                size="small"
                                className="addStaff-input removeShadow"
                                name="lmcid"
                                placeholder="Enter"
                                value={item.name}
                              />
                            </Tooltip>
                          );
                        })}
                      </div>
                    </Form.Item>
                  </div>
                  <Row>
                    {/* <div className="addStaff-text">Delete Edit</div> */}
                    <div>
                      <div>
                      <div>{"Delete  Edit"}</div>
                        <span className="mx-2 deleteEventBorder px-2 pb-1 fileError addCursor">.
                        {/* <div>Delete</div> */}
                          <img
                            src={DeleteIcon}
                            alt="delete"
                            height="50%"
                            onClick={() => documentAction("delete")}
                          />
                        </span>
                        
                        <span className="deleteEventBorder px-2 pb-1 textBlue addCursor">
                          <img
                            src={EditIcon}
                            alt="edit"
                            height="50%"
                            onClick={() => documentAction("edit")}
                          />
                        </span>
                      </div>
                    </div>
                  </Row>
                </div>
              </>
            )}
            {showDocument && (
              <AddAttachment
                // activeKey={props.activeKey}
                // isUpdateModel={isUpdateModel}
                handleCancel={handleCancel}
                handleOk={handleOk}
                // remove={props.remove}
                ticketData={ticketData}
                setTicketData={setTicketData}
              />
            )}
            <DeleteModal
              deleteModal={deleteModel}
              handleCancel={handleCancel}
              handleOk={() => {
                setTicketData({
                  ...ticketData,
                  Files: [],
                });
                handleCancel();
              }}
            />
          </div>

          <div className="fieldBackground">
            <div className="addIncident">03. Point Of Contact</div>
            <div className="formDesignRow">
              <div style={{ width: "18%" }}>
                <span className="addStaff-text">
                  User's Name <span style={{ color: "red" }}>*</span>
                </span>
                <Form.Item>
                  {getFieldDecorator("pocName", {
                    rules: [
                      {
                        required: true,
                        message: "This field is mandatory",
                      },
                    ],
                    initialValue: ticketData.POCName,
                  })(
                    <Input
                      size="small"
                      name="pocName"
                      placeholder="Enter"
                      value={ticketData.POCName}
                      onChange={handlePOCNameChange}
                      maxLength={150}
                    />
                  )}
                </Form.Item>
                {ticketData.POCName?.length > 149 && (
                  <div className="customErrorText">
                    This field allows up to 150 characters only.
                  </div>
                )}
              </div>

              <div style={{ width: "18%" }}>
                <span className="addStaff-text">
                  Contact No. <span style={{ color: "red" }}>*</span>
                </span>
                <Form.Item>
                  {getFieldDecorator("pocContactNumber", {
                    rules: [
                      {
                        required: true,
                        message: "This field is mandatory",
                      },
                      // {
                      //     pattern : /^[0-9\b]+$/,
                      //     message: "Type Number Only",

                      // }
                    ],
                    initialValue: ticketData.POCContactNumber,
                  })(
                    <Input
                      size="small"
                      name="pocContactNumber"
                      placeholder="Enter"
                      value={ticketData.POCContactNumber}
                      onChange={handlePOCPhoneChange}
                      maxLength={50}
                    />
                  )}
                </Form.Item>
                {ticketData.POCContactNumber?.length > 49 && (
                  <div className="customErrorText">
                    This field allows up to 50 characters only.
                  </div>
                )}
              </div>

              <div style={{ width: "18%" }}>
                <span className="addStaff-text">
                  Email Address <span style={{ color: "red" }}>*</span>
                </span>
                <Form.Item>
                  {getFieldDecorator("pocEmail", {
                    rules: [
                      {
                        required: true,
                        message: "This field is mandatory",
                      },
                      {
                        // pattern: new RegExp(/^[A-Za-z][\w$.]+@[\w]+\.\w+$/), //oRIGINAL
                        pattern: new RegExp(
                          /^[a-zA-Z0-9!#$%&'*+-/=?^_`{|]{1,64}@[a-zA-Z0-9!#$%&'*+-/=?^_`{|]+\.[a-z]{2,4}$/
                        ),
                        message: (
                          <span
                            style={{ fontSize: "12px", marginRight: "5px" }}
                          >
                            Enter a valid email id
                          </span>
                        ),
                      },
                      // {
                      //     type: "email",
                      //     message: "Enter valid email address"
                      // }
                    ],
                    initialValue: ticketData.POCEmail,
                  })(
                    <Input
                      size="small"
                      name="pocEmail"
                      placeholder="Enter"
                      value={ticketData.POCEmail}
                      onChange={handlePOCEmailChange}
                      maxLength={150}
                    />
                  )}
                </Form.Item>
                {ticketData.POCEmail?.length > 149 && (
                  <div className="customErrorText">
                    This field allows up to 150 characters only.
                  </div>
                )}
              </div>
            </div>
            <div>
              <div className="checkBoxAlignment">
                <Form.Item>
                  <span>
                    <input
                      type="checkbox"
                      className="complaintsCheckBox"
                      checked={copyToPOC}
                      onChange={handleCheckBox}
                    />{" "}
                    <span className="complaintText">
                      Same as logged in user
                    </span>
                  </span>
                </Form.Item>
              </div>
            </div>
          </div>
          <Form.Item>
            <div className="incidentCancelButtonPosition">
              <div>
                <PrimaryButton
                  className={"simple-button1"}
                  onClick={warning}
                  label={"Cancel"}
                />
              </div>
              <div> </div>
              <div>
                <PrimaryButton
                  className={"details-tab1"}
                  onClick={ticketCreate}
                  label={"Create"}
                />
              </div>
            </div>
          </Form.Item>
          {/* } */}
        </Form>
      </>
    </div>
  );
}

const WrappedMyForm = Form.create({ name: "my-form" })(CreateTicket);
export default WrappedMyForm;
